export const API_PATH_ApiLanePlanningPost = '/services/lane-planning/apiLanePlanningPost';
